import { useCallback } from "react";
import { createFileRoute } from "@tanstack/react-router";
import { ExperimentsPage } from "@/components/experiments/experiments-page";
import { parseExperimentsSearch, type ExperimentsSearch } from "@/components/experiments/search";

export const Route = createFileRoute("/_app/$workspaceSlug/$projectSlug/experiments")({
  // Which experiment is open lives in the URL and nowhere else. Whatever the
  // URL says, this returns a page that can be drawn: it never throws.
  validateSearch: (search: Record<string, unknown>): ExperimentsSearch =>
    parseExperimentsSearch(search),
  component: ExperimentsRoute,
});

function ExperimentsRoute() {
  const { projectSlug } = Route.useParams();
  const search = Route.useSearch();
  const navigate = Route.useNavigate();
  const setSearch = useCallback(
    (next: ExperimentsSearch) => void navigate({ search: next }),
    [navigate],
  );
  // Keyed by project: the open experiment is one project's.
  return <ExperimentsPage key={projectSlug} search={search} onSearchChange={setSearch} />;
}
